import { render, staticRenderFns } from "./rewardRecord.vue?vue&type=template&id=f0771b46&scoped=true"
import script from "./rewardRecord.vue?vue&type=script&lang=js"
export * from "./rewardRecord.vue?vue&type=script&lang=js"
import style0 from "./rewardRecord.vue?vue&type=style&index=0&id=f0771b46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0771b46",
  null
  
)

export default component.exports